export default {
    active: 'เปิด',
    inactive: 'ปิด'
}
